import React, { useEffect, useState, useRef } from 'react';

const ValidationMessage = ({ taskValidation, initialCountdown, clearDataFetchInterval }) => {
  const [countdown, setCountdown] = useState(initialCountdown);
  const countdownIntervalId = useRef(null);

  useEffect(() => {
    if (taskValidation) {
      clearDataFetchInterval();
      clearInterval(countdownIntervalId.current);
    } else {
      countdownIntervalId.current = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);

      return () => clearInterval(countdownIntervalId.current);
    }
  }, [taskValidation, clearDataFetchInterval]);

  useEffect(() => {
    return () => clearInterval(countdownIntervalId.current);
  }, []);

  if (taskValidation) {
    if (taskValidation.toLowerCase() === "error") {
      return (
        <div style={{ background: 'red' }} className={"content-block dx-card signers"}>
          <p style={{ color: 'white', textAlign: "center" }}>
            ארעה תקלה &#33;
          </p>
        </div>
      );
    } else if (taskValidation.toLowerCase() === "ok") {
      return (
        <div style={{ background: 'green' }} className={"content-block dx-card signers"}>
          <p style={{ color: 'white', textAlign: "center" }}>
            המסמך נשלח בהצלחה  &#10004;
          </p>
        </div>
      );
    }
  }

  return (
    <div style={{ background: 'orange' }} className={"content-block dx-card signers"}>
      <p style={{ color: 'white', textAlign: "center" }}>
        המסמך בתהליך    &#10004; <br />
        <span id="countdown">{countdown}</span>
      </p>
    </div>
  );
};

export default ValidationMessage;
